<form [formGroup]="resourceSpecificInfoForm">
    <div class="container-fluid direct-client-personal-info-edit-card tc-card-wrapper">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="tc-flex-box">
                    <div class="tc-flex-item tc-item-circle">
                        <div class="icon-box">
                            <i class="material-icons">directions_car</i>
                        </div>
                    </div>
                    <div class="tc-flex-item tc-right-cage">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">

                                <div class="tc-select-edit dcpiec-select-title">
                                    <mat-form-field>
                                        <mat-select
                                            #transferModeSelect
                                            id="DIR_PER_INFO_EDIT_TRANSFER_MODE"
                                            formControlName="transferMode"
                                            [placeholder]="'Transfer Mode' | translate"
                                            (valueChange)="onTransferModeChange($event)"
                                            required>

                                            <mat-option
                                                    id="DIR_PER_INFO_EDIT_TRANSFER_MODE_{{transferModes}}"
                                                    *ngFor="let modes of transferModes"
                                                    [value]="modes.code">
                                                {{modes.code}} | {{modes.name}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                                class="mat-error"
                                                role="alert">{{getErrorMessage('transferMode')}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-fname">
                                    <mat-form-field>
                                        <mat-select
                                                #transferModeSelect
                                                id="DIR_PER_INFO_EDIT_VEHICLE_MODEL"
                                                formControlName="vehicleModel"
                                                [placeholder]="'Vehicle Model'"
                                                (valueChange)="onVehicleModeChange($event)"
                                                required>

                                            <mat-option
                                                    id="DIR_PER_INFO_EDIT_VEHICLE_MODEL_{{filteredVehicleModels}}"
                                                    *ngFor="let vehicleModel of filteredVehicleModels"
                                                    [value]="vehicleModel.code">
                                                {{vehicleModel.name}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>{{getErrorMessage('vehicleModel')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-fname">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                formControlName="vehicleName"
                                                [placeholder]="'Vehicle Name' | translate"
                                                required
                                        >
                                        <mat-error>{{getErrorMessage('vehicleName')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-lname">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                id="DIR_PER_INFO_EDIT_LNAME"
                                                #lNameInput
                                                formControlName="licenseNumber"
                                                [placeholder]="'License Plate Number' | translate"
                                                required
                                        >
                                        <mat-error>{{getErrorMessage('licenseNumber')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-lname">
                                    <mat-form-field>
                                        <mat-select
                                                placeholder="Fuel Type" name="gender" formControlName="fuelType"
                                                required>
                                            <mat-option
                                                    *ngFor="let fuelTypes of fuelTypeOptions"
                                                    [value]="fuelTypes">
                                                {{fuelTypes}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>{{getErrorMessage('fuelType')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-dob">
                                    <mat-form-field>
                                        <input
                                                matInput

                                                [placeholder]="'Fuel Consumption' | translate"
                                                name="dateOfBirth"
                                                formControlName="fuelConsumption">
                                        <mat-error>{{getErrorMessage('fuelConsumption')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">

                                <div class="tc-select-edit dcpiec-select-title">
                                    <mat-form-field>

                                        <input
                                                matInput
                                                id="DIR_PER_INFO_DRIVER_NAME"
                                                #driverInput
                                                formControlName="driver"
                                                [placeholder]="'Driver' | translate"
                                                [matAutocomplete]="autoD"
                                                (focus)="onDriverFocus($event)">
                                        <button
                                                mat-button
                                                matSuffix
                                                mat-icon-button
                                                aria-label="Clear"
                                                [disabled]="false"
                                                (click)="clearDriver()">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-error
                                                class="mat-error"
                                                role="alert">{{getErrorMessage('driver')}}
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-autocomplete #autoD="matAutocomplete" [displayWith]="displayDriverFn">
                                        <mat-option
                                                *ngFor="let driver of filteredDrivers"
                                                [value]="driver"
                                                (onSelectionChange)="onSelectDriver(driver)">
                                            <span>{{displayDriverFn(driver)}}</span> |
                                            <small>{{driver?.resourceId ? driver.resourceId : ''}}</small>
                                        </mat-option>
                                    </mat-autocomplete>

                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-licenseNumber">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                formControlName="seatingCapacity"
                                                [placeholder]="'Seating Capacity' | translate"
                                                required
                                        >
                                        <mat-error>{{getErrorMessage('seatingCapacity')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>


                        </div>
                        <div class="row">

                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-passportNumber">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                id="DIR_PER_INFO_EDIT_PASSPORTNUMBER"
                                                formControlName="minPax"
                                                [placeholder]="'Min Pax' | translate"

                                                required
                                        >
                                        <mat-error>{{getErrorMessage('minPax')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-passportNumber">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                formControlName="maxPax"
                                                [placeholder]="'Max Pax' | translate"
                                                required
                                        >
                                        <mat-error>{{getErrorMessage('maxPax')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-select-edit dcpiec-select-title">


                                    <mat-form-field class="example-full-width">
                                        <input
                                                matInput
                                                id="DIR_PER_INFO_SUPPLIER_NAME"
                                                #supplierInput
                                                formControlName="supplier"
                                                [placeholder]="'Supplier' | translate"
                                                [matAutocomplete]="autoS"
                                                (focus)="onSupplierFocus($event)"
                                                required>
                                        <button
                                                mat-button
                                                matSuffix
                                                mat-icon-button
                                                aria-label="Clear"
                                                [disabled]="false"
                                                (click)="clearSupplier()">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-error
                                                class="mat-error"
                                                role="alert">{{getErrorMessage('supplier')}}
                                        </mat-error>
                                        <mat-hint *ngIf="missingCostForSupplier">Supplier cost is not available</mat-hint>
                                    </mat-form-field>
                                    <mat-autocomplete #autoS="matAutocomplete" [displayWith]="displaySupplierFn">
                                        <mat-option
                                                *ngFor="let supplier of filteredSuppliers"
                                                [value]="supplier"
                                                (onSelectionChange)="onSelectSupplier(supplier)">
                                            <span>{{supplier?.name ? supplier.name : ''}}</span> |
                                            <small>{{supplier?.code ? supplier.code : ''}}</small>
                                        </mat-option>
                                    </mat-autocomplete>

                                </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-fname">
                                    <mat-form-field>
                                        <mat-select
                                            #localeInput
                                            id="DIR_PER_INFO_EDIT_SUPPLIER_TYPE"
                                            formControlName="supplierType"
                                            [placeholder]="'Profile Type' | translate"
                                        >
                                            <mat-option *ngFor="let option of supplierTypes" [value]="option.code">
                                                {{option.name}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="tc-input-edit dcpiec-input-businessType">
                                    <mat-form-field>
                                        <mat-select #localeInput
                                                    id="DIR_PER_INFO_EDIT_BUSINESS_TYPE"
                                                    formControlName="businessType"
                                                    [placeholder]="'Business Type'" required>
                                            <mat-option *ngFor="let option of businessTypes | keyvalue" [value]="option.key">
                                                {{option.value}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>{{getErrorMessage('businessType')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-preference">
                                    <mat-form-field>
                                        <input matInput
                                               id="DIR_PER_INFO_EDIT_PREFERENCE"
                                               #preferenceInput
                                               formControlName="preference"
                                               [placeholder]="'Preference'"
                                        >
                                        <mat-error>{{getErrorMessage('preference')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">
                                <div class="tc-input-edit dcpiec-input-grade">
                                    <mat-form-field>
                                        <mat-select #localeInput
                                                    id="DIR_PER_INFO_EDIT_GRADE"
                                                    [(ngModel)]="gradeNgModel"
                                                    [placeholder]="'Grade'"
                                                    (selectionChange)="gradeSelectionOnChange($event)"
                                                    [ngModelOptions]="{standalone: true}">
                                            <mat-option *ngFor="let single of grades" [value]="single?.order">
                                                {{single?.displayName}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>{{getErrorMessage('grade')}}</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 remove-bootstrap-padding-mobile">

                                <mat-form-field>
                                    <input
                                            matInput
                                            id="DIR_PER_INFO_USER_NAME"
                                            #userInput
                                            formControlName="linkedUser"
                                            [placeholder]="'Linked User'"
                                            [matAutocomplete]="autoUser"
                                            (focus)="onUserFocus($event)">
                                    <button
                                            mat-button
                                            matSuffix
                                            mat-icon-button
                                            aria-label="Clear"
                                            [disabled]="false"
                                            (click)="clearUser()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                    <mat-error>{{getErrorMessage('linkedUser')}}</mat-error>
                                </mat-form-field>
                                <mat-autocomplete #autoUser="matAutocomplete" [displayWith]="displayUserFn">
                                    <mat-option
                                            *ngFor="let user of filteredUsers"
                                            [value]="user"
                                            (onSelectionChange)="onSelectUser(user)">
                                        <span>{{getUserName(user)}}</span>
                                    </mat-option>
                                </mat-autocomplete>
                            </div>
                            <div class="col-xs-12 col-sm-6  col-md-3 col-lg-3">
                                <div class="tc-content--wrap tc-input-view">
                                </div>
                                <img
                                        *ngIf="resourceSpecificInformationModel?.userProfile?.imageUrl"
                                        width="50px"
                                        height="50px"
                                        style="border-radius: 50%"
                                        [src]="resourceSpecificInformationModel?.userProfile?.imageUrl"
                                        alt="user image">
                            </div>
                        </div>

                        <div class="tc-action-chip-list-wrapper tc-chip-selector__action-chips">
                            <div
                                    class="tc-action-chip"
                                    (click)="toggleActiveValue()"
                                    [ngClass]=" activeFlag ?'tc-action-chip--active':'tc-action-chip--inactive' ">
                                <span class="tc-action-chip__icon tc-action-chip__icon-man"></span>
                                <span class="tc-action-chip__icon tc-action-chip__icon-select">
                                  <i class="material-icons">done</i>
                                </span>
                                <div class="tc-action-chip__text">
                                    {{'Active' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
